import { Component, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DialogAbstractComponent } from '../../shared/dialogs/dialog.class';
import { GlobalValidators } from '../../utils/utils';
import { AccountService } from './../../services/account.service';

@Component({
  selector: 'app-email-confirmation',
  templateUrl: './email-confirmation.component.html',
  styleUrls: ['./email-confirmation.component.scss'],
})
export class EmailConfirmationComponent extends DialogAbstractComponent implements OnInit {
  currentUser: any;

  confirmEmailFG: FormGroup;
  verifySignupFG: FormGroup;
  sentVerification: boolean;
  sendingCodeInProgress: boolean;
  verifyingCodeInProgress: boolean;
  verifySuccessMsg: boolean;
  verifySignupErrors: any;
  submittedEmail: String;
  constructor(injector: Injector, private accountService: AccountService, private fb: FormBuilder, private router: Router) {
    super(injector);
  }

  async ngOnInit() {
    this.currentUser = await this.accountService.currentUserAsync();
    this.bindConfirmEmailForm();
    this.bindVerifySignupForm();
  }
  bindConfirmEmailForm() {
    this.confirmEmailFG = this.fb.group({
      email: [this.currentUser.email || '', [GlobalValidators.email, Validators.required]],
    });
    this.confirmEmailFG.valueChanges.subscribe((value) => {
      this.verifySignupErrors = undefined;
      if (this.verifySignupFG) {
        this.verifySignupFG.get('verificationCode').setValue(null);
      }
    });
  }
  bindVerifySignupForm() {
    this.verifySignupFG = this.fb.group({
      email: [this.confirmEmailFG.get('email').value, []],
      verificationCode: ['', [Validators.required]],
    });
  }

  confirmEmail(form) {
    if (form.invalid) {
      this.sendingCodeInProgress = false;
      return;
    }
    this.bindVerifySignupForm();
    this.sendingCodeInProgress = true;
    this.submittedEmail = form.value.email;
    this.accountService
      .sendEmailConfirmation(form.value)
      .then(() => {
        setTimeout(() => {
          this.sendingCodeInProgress = false;
          this.sentVerification = true;
        }, 1000);
      })
      .catch((e) => {
        setTimeout(() => {
          this.sendingCodeInProgress = false;
        }, 600);
      });
  }
  onVerifySignup(form) {
    if (form.invalid) {
      this.verifyingCodeInProgress = false;
      return;
    }
    this.verifyingCodeInProgress = true;
    this.verifySignupErrors = '';

    this.accountService
      .verifyEmailConfirmation(form.value)
      .then(() => {
        this.verifyingCodeInProgress = false;
        this.verifySuccessMsg = true;
        this.accountService.currentUser.emailVerified = true;
        this.accountService.currentUser.email = form.value.email;
        setTimeout(() => {
          this.closeDialog(true);
        }, 1000);
      })
      .catch((e) => {
        this.verifySignupErrors = ['Incorrect verification code'];
        this.verifyingCodeInProgress = false;
      });
  }
  async logout() {
    await this.accountService.signOut().then((data) => {
      this.closeDialog();
      this.router.navigate(['/signin']);
    });
  }
  closeWindow() {
    this.closeDialog(false);
  }
}
